{
  "nl": {
    "building": {
      "attributes": {
        "description": "Omschrijving",
        "elevators": "Aantal liften",
        "end_date": "Einddatum",
        "floors": "Aantal verdiepingen",
        "internal_note": "Interne notitie",
        "name": "Naam",
        "start_date": "Startdatum",
        "surface_shared": "Gemeenschappelijke oppervlakte"
      },
      "labels": {
        "building": "Geen gebouw | Eén gebouw | {count} gebouwen"
      },
      "toasts": {
        "create": "Gebouw aangemaakt",
        "delete": "Gebouw verwijderd",
        "update": "Gebouw gewijzigd"
      },
      "validation": {
        "needName": "Verplicht veld",
        "needNumber": "Moet een getal zijn (bv. 85.5)"
      }
    }
  }
}